import { create } from 'zustand';

/**
 * Which messages you've saved (and when you'll be reminded), so every message
 * can show it. Loaded with the app, kept in step across your devices.
 */
interface SavedState {
  /** messageId → reminder time (null: saved without one). */
  byId: Record<string, string | null>;
  hydrate: (saved: Array<{ messageId: string; remindAt: string | null }>) => void;
  apply: (update: { messageId: string; saved: boolean; remindAt: string | null }) => void;
  reset: () => void;
}

export const useSaved = create<SavedState>((set) => ({
  byId: {},
  hydrate: (saved) => set({ byId: Object.fromEntries(saved.map((s) => [s.messageId, s.remindAt])) }),
  apply: ({ messageId, saved, remindAt }) =>
    set((s) => {
      const byId = { ...s.byId };
      if (saved) byId[messageId] = remindAt;
      else delete byId[messageId];
      return { byId };
    }),
  reset: () => set({ byId: {} }),
}));

/** Whether a message is saved, and its reminder (undefined: not saved). */
export const useSavedState = (messageId: string): string | null | undefined => useSaved((s) => s.byId[messageId]);
